var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsingarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 28,
    viewBox: "0 0 47 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5091 18.4738L6.50913 1.47384C4.39863 -0.551291 -0.601603 4.44871 1.50913 6.47384L21.0091 25.9739C23.3984 27.9482 24.3984 27.9482 26.5091 25.9739L45.5091 6.47384C47.3984 4.44821 42.8984 -0.551766 41.0091 1.47384L23.5091 18.4738Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsingarrow);
export default __webpack_public_path__ + "static/media/collapsingarrow.893cd301b2801f4528bb4eeddf1bbefa.svg";
export { ForwardRef as ReactComponent };